import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { Hipaa } from './shared/hipaa.model';
import { Representative } from 'src/app/models/representative.model';

@Component({
  selector: 'hipaa',
  templateUrl: './hipaa.component.html',
})
export class HipaaComponent {

  isStaff = this.store.state.isStaff;
  title = 'hipaa.title';
  progressBar = this.progress.hippa;
  relationships: Array<string> = this.store.state.relationships;
  potentialRepresentatives: Array<Representative> = this.store.state.potentialRepresentatives;

  firstName = '';
  middleName = '';
  lastName = '';
  relationship = '';
  phoneNumber = '';

  hipaa: Hipaa = this.store.state.consent.hipaa;

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) { }

  clear() {
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';
    this.relationship = '';
    this.phoneNumber = '';
  }

  checkHipaa(checked: boolean) {
    if (!checked) {
      this.hipaa.representatives = [];
      this.potentialRepresentatives.forEach(pr => pr.checked = false)
      this.clear();
    }
  }

  // Add new representative
  addRepresentative() {
    const representative: Representative = {
      firstName: this.firstName,
      middleName: this.middleName,
      lastName: this.lastName,
      relationship: this.relationship,
      phoneNumber: this.phoneNumber,
      checked: true
    };

    this.hipaa.representatives.push(representative);
    this.clear();
  }

  // Add a potential representative (guardian or emergency contact) as a hipaa representative
  addRepresentativeChecked(checked: boolean, representative: Representative) {
    if (checked) {
      this.hipaa.representatives.push(representative);
    } else {
      this.hipaa.representatives = this.hipaa.representatives.filter(rep => rep !== representative);
    }
  }

  disabled(): boolean {
    return this.hipaa.representatives.length > 0;
  }

  back() {
    this.router.navigate([this.navigation.hippa.back]);
  }

  next() {
    this.store.state.consent.hipaa = this.hipaa;
    this.router.navigate([this.navigation.hippa.next]);
  }

}
